import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Breadcrumbs from "components/Common/Breadcrumb";
import DataTable from "../../components/Common/LocalizedDataTable";
import { SalonApi } from "apis/SalonApi";
import { useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Swal from "../../helpers/swal_helper";
import defaultLogo from "assets/images/logo.png";
import moment from "moment";
import config from "config/config";

function useQuery() {
  const { search } = useLocation();
  return new URLSearchParams(search);
}

function Salons(props) {
  const query = useQuery();
  const queryStatus = query.get("status");

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [activeData, setActiveData] = useState({
    page: 1,
    totalRows: 0,
    limit: config.LIMIT,
  });

  useEffect(() => {
    getAllSalons(activeData.page, activeData.limit);
  }, [queryStatus]);

  const columns = [
    {
      name: props.t("Sr.No"),
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: props.t("Icon"),
      cell: (row) => (
        <div
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            overflow: "hidden",
          }}
        >
          <img
            src={row.icon || defaultLogo}
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </div>
      ),
    },
    {
      name: props.t("Name"),
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: props.t("Service At"),
      selector: (row) => row.service_at,
    },
    {
      name: props.t("Status"),
      cell: (row) => (
        <span
          style={{
            fontWeight: "500",
            color:
              row.status === "Approved"
                ? "#03B76B"
                : row.status === "Pending"
                ? "#ffc107"
                : row.status === "Rejected"
                ? "#D13636"
                : "#8D8D8D",
          }}
        >
          {props.t(
            row.status === "Amendment_Required"
              ? "Amendment Required"
              : row.status
          )}
        </span>
      ),
    },
    {
      name: props.t("Date"),
      selector: (row) =>
        queryStatus === "Pending"
          ? moment(row.created_at).format("DD-MM-YYYY")
          : moment(row.updated_at).format("DD-MM-YYYY"),
    },
    {
      name: props.t("Time"),
      selector: (row) =>
        queryStatus === "Pending"
          ? moment(row.created_at).format("hh:mm A")
          : moment(row.updated_at).format("hh:mm A"),
    },
    {
      name: props.t("Action"),
      cell: (row) => (
        <>
          <Link
            style={{ marginRight: "15px" }}
            to={`/edit-salon/${row.id}`}
          >
            <i className="fas fa-edit" />
          </Link>

          <i
            className="mdi mdi-delete font-size-18"
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => onDelete(row.id)}
          />
        </>
      ),
    },
  ];

  const getAllSalons = async (page, limit) => {
    setLoading(true);

    try {
      const res = await SalonApi.getAllSalonsWithoutStatus({
        page: page,
        limit: limit,
        status: queryStatus,
      });

      const response = res.data.data;

      setActiveData({
        page: page,
        totalRows: response.total,
        limit: limit,
      });

      const salons = response.salons.map((v) => ({
        id: v.id,
        icon: v.icon,
        name: v.name,
        service_at: v.service_at,
        status: v.status,
        created_at: v.created_at,
        updated_at: v.updated_at,
      }));

      setData(salons);
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  const handlePageChange = (page) => {
    getAllSalons(page, activeData.limit);
  };

  const handlePerRowsChange = (newLimit, page) => {
    getAllSalons(page, newLimit);
  };

  const onDelete = (id) => {
    Swal.fire({
      title: props.t("Are you sure?"),
      text: props.t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: props.t("Yes, delete it!"),
      cancelButtonText: props.t("Cancel")
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await SalonApi.deleteSalon(id);

        if (res.data.status) {
          Swal.fire(props.t("Deleted!"), res.data.message, "success");
          getAllSalons(activeData.page, activeData.limit);
        }
      }
    });
  };

  document.title = props.t("Salon List");

  return (
    <div className="page-content">
      <div className="container-fluid">

        <Breadcrumbs
          title={props.t("Salon")}
          breadcrumbItem={props.t("Salon List")}
        />

        <DataTable
          columns={columns}
          data={data}
          progressPending={loading}

          pagination
          paginationServer

          paginationTotalRows={activeData.totalRows}
          paginationPerPage={activeData.limit}

          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}

          highlightOnHover
          responsive
        />

      </div>
    </div>
  );
}

Salons.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(Salons);
